import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const CheckInCircle = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      d="M7 14.5834C3.1339 14.5834 0 11.4495 0 7.58337C0 3.71727 3.1339 0.583374 7 0.583374C10.8661 0.583374 14 3.71727 14 7.58337C14 11.4495 10.8661 14.5834 7 14.5834ZM6.3021 10.3834L11.2511 5.43367L10.2613 4.44387L6.3021 8.40377L4.3218 6.42347L3.332 7.41327L6.3021 10.3834Z"
    />
  </svg>
);

CheckInCircle.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

CheckInCircle.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(14, 15),
};

export default CheckInCircle;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/check-in-circle.js